import { useMutation } from '@apollo/client';

import CREATE_CV_UPLOAD_PARSED_CV_MUTATION from './createCvUploadParsedCvMutation.graphql';

const useGetParsedCvData = () => {
  const [createParsedCv] = useMutation(CREATE_CV_UPLOAD_PARSED_CV_MUTATION);

  const getParsedCvData = async uploadId => {
    if (uploadId) {
      const { data } = await createParsedCv({
        variables: { uploadId },
      });

      if (
        data &&
        data.createCvUploadParsedCv &&
        data.createCvUploadParsedCv.id &&
        data.createCvUploadParsedCv.personal
      ) {
        const {
          id,
          personal: { emails, firstName = '', lastName = '' },
        } = data.createCvUploadParsedCv;

        let email;
        if (emails && emails[0]) {
          if (emails[0].email) {
            email = emails[0].email;
          } else if (typeof emails[0] === 'string') {
            email = emails[0];
          }
        }

        return { email, firstName, lastName, id };
      }
    }

    return null;
  };

  return { getParsedCvData };
};

export default useGetParsedCvData;
